const transactions = {
  defaults: {
    outcomeLength: 1,
  },
}

export default transactions
